const Wine = (props) => {
  const { product } = props;
  if (product.type !== 'Wine') {
    return null;
  }
  const { wine } = product;
  return (
    <div className="c7-product-specs">
      <h2>Wine Specs</h2>

      {renderVintage(wine.vintage)}
      {renderVarietal(wine.varietal)}
      {renderAppellation(wine.appellation)}
    </div>
  );
};

const renderVintage = (vintage) => {
  if (!vintage) {
    return null;
  }
  return (
    <div className="c7-product-spec">
      <div>Vintage</div>
      <div>{vintage}</div>
    </div>
  );
};

const renderVarietal = (varietal) => {
  if (!varietal) {
    return null;
  }
  return (
    <div className="c7-product-spec">
      <div>Varietal</div>
      <div>{varietal}</div>
    </div>
  );
};

const renderAppellation = (appellation) => {
  if (!appellation) {
    return null;
  }
  return (
    <div className="c7-product-spec">
      <div>Appellation</div>
      <div>{appellation}</div>
    </div>
  );
};

export default Wine;
